import React from "react"
import { createTheme, ThemeProvider, CssBaseline, makeStyles } from '@material-ui/core'
import "@fontsource/lora"
import "@fontsource/raleway"
import "@fontsource/poppins"

const useGlobalStyles = makeStyles({
  "@global": {
    body: {
      margin:"0px",
      backgroundColor: "#fff"
    }
  }
});
const theme = createTheme({
  typography: {
    fontFamily: [
      'Lora',
      'KnowledgeLight',
      'Raleway',
      'Open Sans',
      'Helvetica',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontFamily: ['Lora'],
      letterSpacing:"-1px",
      fontSize:"2rem",
      color: "#10452c",
      '@media (min-width:780px)': {
        fontSize:"2.6rem",
        lineHeight: "2.8rem"
      }
    },
    h2: {
      fontFamily: ['Lora'],
      fontSize:"1.6rem",
      color: "#10452c",
      '@media (min-width:780px)': {
        fontSize:"1.8rem",
      }
    },
    h3: {
      fontFamily: ['Lora'],
      letterSpacing:"-1px",
      fontSize:"2.6rem",
      color: "#10452c",
      '@media (min-width:780px)': {
        fontSize:"2.6rem",
      }
    },
    h6: {
      fontFamily: ['Lora'],
      letterSpacing:"-1px",
      fontSize:"1.4rem",
      color: "#10452c",
      marginBottom:"12px",
      '@media (min-width:780px)': {
        fontSize:"1.4rem",
      }
    },
    body1:{
      fontFamily: [
        'Lora',
        'Raleway',
        'Poppins',
        'Helvetica',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      fontSize: "1rem",
      lineHeight:"1rem",
      fontWeight: 400,
      letterSpacing:"0px",
      color: "#494949",
      textShadow: "none",
      "@media (min-width:600px)": {
        fontSize: "1rem",
        lineHeight:"1rem",
      },
    },
    body2:{
      // textShadow: "2px 2px #000",
      letterSpacing:"0px",
      color: "#fff",
    },
    button: {
      paddingTop:"12px",
      paddingBottom:"12px",
      paddingRight:"20px",
      paddingLeft:"20px",
      backgroundColor: "#10452c",
      color: "#fff",
      fontWeight: 500,
      textTransform: "none",
      "& a" :{
        color:"#fff",
        textDecoration:"none",
        fontSize:"0.9rem",
        paddingTop:"12px",
        paddingBottom:"12px",
        paddingRight:"20px",
        paddingLeft:"20px",
      }

    }
  },
  palette: {
    primary: {
      main: '#ccc'
    },
  },
  overrides: {

  }

});

function MyThemeProvider({ children }) {
  useGlobalStyles();
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

const Theme = ({ path, children }) => {
  return (
    <MyThemeProvider>
      <CssBaseline />
      {children}
    </MyThemeProvider>
  )
}
export default Theme